module.exports = __webpack_public_path__ + "img/img15.1a0d024f.svg";